import React, {FC} from 'react';
import {Link} from 'react-router-dom';
import classNames from 'classnames';

import {RoutePathType} from 'constants/flow/flowTypes';

import s from './title.scss';

type PropsType = {
    url?: string | RoutePathType;
    title?: string;
    onClick?: () => void;
    placeholder?: boolean;
    onTouchStart?: () => void;
    onTouchEnd?: () => void;
};

/**
 * Category Item Title Component
 * @param {PropsType} props - component properties
 * @returns {Node} rendered component
 */
export const ItemTitle: FC<PropsType> = React.memo(
    ({children, url = '', title, onClick, placeholder = false, onTouchStart, onTouchEnd}) =>
        placeholder ? (
            <div className={classNames(s.container, s.placeholder)} />
        ) : (
            <Link
                data-test-name="productTitle"
                to={url}
                title={title}
                className={s.container}
                onClick={onClick}
                onTouchStart={onTouchStart}
                onTouchEnd={onTouchEnd}
            >
                {children}
            </Link>
        ),
);
